export const homeFeatures = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: 'JMTT平台采用先进的加密技术与多重安全防护机制，确保您的数据与交易安全无忧，让您放心使用每一项服务。'
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '高效便捷',
    description: 'JMTT致力于提供极致的用户体验，简洁直观的操作界面配合智能化的流程设计，让您轻松完成各项操作。'
  },
  {
    id: 3,
    icon: 'ri-global-line',
    title: '全球覆盖',
    description: 'JMTT的服务网络覆盖全球多个国家和地区，无论您身在何处，都能享受到JMTT带来的优质服务与专业支持。'
  },
  {
    id: 4,
    icon: 'ri-customer-service-2-line',
    title: '专业支持',
    description: 'JMTT拥有经验丰富的专业团队，提供7×24小时全天候客户服务，随时为您解答疑问、处理问题。'
  }
];

export const coreServices = [
  {
    id: 1,
    icon: 'ri-database-2-line',
    title: '数据管理服务',
    description: '提供全方位的数据存储、处理与分析解决方案，帮助您高效管理业务数据，挖掘数据价值，驱动业务增长。',
    highlights: ['云端存储', '实时同步', '智能分析']
  },
  {
    id: 2,
    icon: 'ri-exchange-funds-line',
    title: '交易处理平台',
    description: '安全稳定的交易处理系统，支持多种交易模式与支付方式，为您的业务提供可靠的技术支撑与保障。',
    highlights: ['多重加密', '秒级到账', '风险监控']
  },
  {
    id: 3,
    icon: 'ri-bar-chart-grouped-line',
    title: '智能营销工具',
    description: '基于大数据与人工智能技术，提供精准的用户画像分析、智能推荐与自动化营销方案，助力业务快速增长。',
    highlights: ['用户画像', '精准触达', '效果追踪']
  },
  {
    id: 4,
    icon: 'ri-team-line',
    title: '协作办公套件',
    description: '集成即时通讯、文档协作、项目管理等功能的一站式办公平台，提升团队协作效率，降低沟通成本。',
    highlights: ['实时协作', '权限管理', '版本控制']
  },
  {
    id: 5,
    icon: 'ri-shield-user-line',
    title: '身份认证系统',
    description: '提供安全可靠的身份验证与权限管理服务，支持多因素认证，全方位保障账户安全与合规运营。',
    highlights: ['多因素认证', '生物识别', '合规审计']
  },
  {
    id: 6,
    icon: 'ri-smartphone-line',
    title: '移动端解决方案',
    description: '针对移动场景深度优化的应用方案，支持iOS与Android双平台，让您随时随地畅享JMTT服务。',
    highlights: ['双端适配', '离线可用', '推送通知']
  }
];

export const testimonials = [
  {
    id: 1,
    name: '张伟',
    role: '某科技公司CEO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%20in%20suit%2C%20clean%20white%20studio%20background%2C%20warm%20friendly%20smile%2C%20corporate%20headshot%20photography%2C%20soft%20natural%20lighting%2C%20high%20quality%20professional%20portrait&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '自从接入JMTT平台以来，我们的业务效率提升了40%以上。JMTT的数据管理服务帮助我们更好地理解和服务客户，是真正的企业级解决方案。强烈推荐给每一位寻求数字化转型的企业。',
    rating: 5,
    date: '2026年6月'
  },
  {
    id: 2,
    name: '李婷',
    role: '电商运营总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%2C%20modern%20office%20attire%2C%20confident%20expression%2C%20clean%20light%20background%2C%20corporate%20headshot%20photography%2C%20warm%20natural%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: 'JMTT的交易处理平台稳定性和安全性令人印象深刻。我们的日交易量增长了3倍，但系统从未出现任何问题。客服团队的响应速度也非常快，真正做到了让用户无忧。',
    rating: 5,
    date: '2026年7月'
  },
  {
    id: 3,
    name: '王浩',
    role: '独立开发者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20tech%20professional%20portrait%2C%20casual%20modern%20style%2C%20friendly%20confident%20look%2C%20clean%20minimal%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '作为一名独立开发者，JMTT的协作办公套件让我的工作效率大大提升。文档协作和项目管理功能非常实用，而且移动端的体验也很出色，随时随地都能处理工作。',
    rating: 5,
    date: '2026年5月'
  },
  {
    id: 4,
    name: '赵敏',
    role: '金融行业分析师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20analyst%20portrait%2C%20elegant%20business%20attire%2C%20warm%20professional%20smile%2C%20clean%20studio%20lighting%2C%20corporate%20headshot%20photography&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: 'JMTT的智能营销工具帮助我们在三个月内将用户转化率提高了25%。数据分析精准，营销建议非常实用，是一个真正懂业务的好平台。',
    rating: 4,
    date: '2026年8月'
  }
];

export const faqItems = [
  {
    id: 1,
    question: 'JMTT平台如何注册？',
    answer: '注册JMTT非常简单！您只需访问JMTT官网，点击右上角的"立即注册"按钮，填写基本信息并验证手机号或邮箱，即可完成注册。整个过程只需2-3分钟。注册后您将立即获得基础功能的访问权限。'
  },
  {
    id: 2,
    question: 'JMTT平台支持哪些支付方式？',
    answer: 'JMTT平台支持多种支付方式，包括银行转账、支付宝、微信支付以及主流信用卡。我们持续优化支付体验，确保每一笔交易都安全、便捷。具体支持的支付方式可能因您的账户类型和所在地区而略有不同。'
  },
  {
    id: 3,
    question: 'JMTT的数据安全如何保障？',
    answer: 'JMTT采用银行级别的加密技术保护您的数据安全。我们通过了多项国际安全认证，采用SSL/TLS加密传输、数据分片存储、定期安全审计等多重防护措施，确保您的数据始终安全无虞。'
  },
  {
    id: 4,
    question: 'JMTT提供免费试用吗？',
    answer: '是的！JMTT为所有新注册用户提供14天的免费试用期，您可以在试用期内完整体验所有功能。试用期结束后，您可以根据自己的需求选择适合的套餐方案，无需担心被强制收费。'
  },
  {
    id: 5,
    question: '如果在使用JMTT过程中遇到问题怎么办？',
    answer: 'JMTT提供7×24小时的客户支持服务。您可以通过在线客服、官方邮箱、客服热线等多种渠道联系我们的专业支持团队。此外，我们还提供详细的JMTT使用教程和常见问题解答，帮助您快速解决问题。'
  },
  {
    id: 6,
    question: 'JMTT支持团队协作吗？',
    answer: '当然支持！JMTT的协作办公套件专为团队设计，支持多成员同时在线协作。您可以灵活设置不同的权限级别，确保信息安全的同时最大化协作效率。平台支持实时同步，所有成员都能看到最新的工作进展。'
  }
];

export const stats = [
  { id: 1, value: '500万+', label: '活跃用户' },
  { id: 2, value: '99.9%', label: '服务可用率' },
  { id: 3, value: '200+', label: '覆盖国家与地区' },
  { id: 4, value: '10亿+', label: '累计处理交易' }
];